import axios from '../shared/axios';

export const globalSearch = (query, entityType, take, skip, contractId, isExactMatch) => {
  return axios.get(`/api/Search/Global`, {
    params: {
      query: query,
      entityType: entityType || null,
      take: take || 500,
      skip: skip || 0,
      contractId: contractId || null,
      isExactMatch: !!isExactMatch
    }
  });
};